// One query-key factory for every resource (ADR 0005). Everything about a
// resource starts with [res], so invalidating keys.all(res) refreshes its
// lists, records and "all records" fetches together.
import type { RecordId } from './types'

export const keys = {
  all: (res: string) => [res] as const,
  list: (res: string, params: unknown) => [res, 'list', params] as const,
  infinite: (res: string, params: unknown) => [res, 'infinite', params] as const,
  one: (res: string, id: RecordId, tenantId?: string | number) =>
    (tenantId === undefined
      ? [res, 'one', id]
      : [res, 'one', id, { tenantId }]) as readonly unknown[],
  allRecords: (res: string, params: unknown) => [res, 'allRecords', params] as const
}
